import {CircularProgress} from '@mui/material';
import Box from '@mui/material/Box';
import type * as React from 'react';
import {useEffect, useState} from 'react';
import MyCapacityDashboard from '@/components/Capacity/MyCapacityDashboard';
import {useGetCapacityDateConfig} from '@/hooks/capacity/useGetCapacityDateConfig';
import {useGetSelf} from '@/hooks/useGetSelf';
import type {CapacityConfig} from '@/types/CapacityConfig';
import type {Employee} from '@/types/Employee';

const MyCapacityDashboardWrapper = () : React.ReactElement => {
    const [capacityConfig, setCapacityConfig] = useState<CapacityConfig | null>(null);
    const [self, setSelf] = useState<Employee | null>(null);

    const getCapacityDateConfigQuery = useGetCapacityDateConfig();
    const useGetSelfQuery = useGetSelf();

    useEffect(() => {
        if (useGetSelfQuery.data !== undefined && self == null) {
            setSelf(useGetSelfQuery.data);
        }
    }, [useGetSelfQuery]);

    useEffect(() => {
        if (getCapacityDateConfigQuery.data !== undefined && capacityConfig == null) {
            setCapacityConfig(getCapacityDateConfigQuery.data);
        }
    }, [getCapacityDateConfigQuery]);

    if (!self || capacityConfig === null) {
        return <Box>
            Two
            <CircularProgress/>
        </Box>;
    }

    return <MyCapacityDashboard
        self={self}
        capacityConfig={capacityConfig}
    />;
};

export default MyCapacityDashboardWrapper;
